export default "__VITE_ASSET__CJU7q1Vp__"